module.exports = __webpack_public_path__ + "img/NO984150865.36fd9488.svg";